// How long BossDrop keeps excerpts of tracked email (Control Room > Email
// tracking). The backend applies the same rule when the setting is saved and
// deletes each excerpt that many days after storing it
// (server/mail/emailRetention.js).

export const EMAIL_RETENTION_CHOICES = [30, 60, 90, 180, 365];
export const DEFAULT_EMAIL_RETENTION_DAYS = 30;

/** One of the choices, else 30. Accepts numbers or numeric strings. */
export function normalizeEmailRetentionDays(value) {
  if (value === null || value === undefined || value === "") return DEFAULT_EMAIL_RETENTION_DAYS;
  const n = Number(value);
  return EMAIL_RETENTION_CHOICES.includes(n) ? n : DEFAULT_EMAIL_RETENTION_DAYS;
}

export const EMAIL_RETENTION_OPTIONS = [
  { value: "30", label: "30 days (default)" },
  { value: "60", label: "60 days" },
  { value: "90", label: "90 days" },
  { value: "180", label: "180 days" },
  { value: "365", label: "1 year" },
];
